import React from 'react'
import { Redirect, Route, RouteComponentProps, RouteProps } from 'react-router-dom'
import { Pages } from '../router'
import { useKeycloak } from '@react-keycloak/web'
import { isClientUser } from '../../services/keycloak.service'
import { useSelector } from '../../redux/hooks/useSelector'
import { isDistributorUser } from '../../utils/distributor'

interface PrivateRouteParams extends RouteProps {
  component: React.ComponentType<RouteComponentProps<any>> | React.ComponentType<any>
  protectedRoute: boolean
  distributorAllowed?: boolean
}

export function PrivateRoute({ component: Component, protectedRoute, distributorAllowed, ...rest }: PrivateRouteParams) {
  const { keycloak } = useKeycloak()
  const user = useSelector(state => state.auth.user)

  return (
    <Route
      {...rest}
      render={props => {
        if (!keycloak?.authenticated) {
          return (
            <Redirect
              to={{
                pathname: Pages.Login,
                state: { from: props.location },
              }}
            />
          )
        } else if (protectedRoute && isClientUser()) {
          return (
            <Redirect
              to={{
                pathname: Pages.AccessForbidden,
                state: { from: props.location },
              }}
            />
          )
        } else if (!distributorAllowed && isDistributorUser(user)) {
          return (
            <Redirect
              to={{
                pathname: Pages.AccessForbidden,
                state: { from: props.location },
              }}
            />
          )
        } else {
          return <Component {...props} />
        }
      }}
    />
  )
}
